import { render, staticRenderFns } from "./updatepparth.vue?vue&type=template&id=689b1cbd&scoped=true&"
import script from "./updatepparth.vue?vue&type=script&lang=js&"
export * from "./updatepparth.vue?vue&type=script&lang=js&"
import style0 from "./updatepparth.vue?vue&type=style&index=0&id=689b1cbd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b1cbd",
  null
  
)

export default component.exports